// One row in the Logs panel. Layout:
//
//   timestamp (UTC long form) · level · source · cadence · message · pipeline_label
//
// `record_count` (when present in metrics) is appended inline to the message
// as a small chip - keeps the message column scannable while still surfacing
// the count without forcing the user to drill down.

import {
  cadenceClass,
  cadenceLabel,
  extractRecordCount,
  formatMessage,
  formatSource,
  formatTimestamp,
} from "../format";
import type { PipelineCadence, PipelineEvent } from "../types";

export function LogRow({
  event,
  cadenceBySource,
  onClick,
}: {
  event: PipelineEvent;
  // Live per-source cadence from the Data Health endpoint; absent -> the
  // cadence helpers fall back to the pipeline-slug heuristic.
  cadenceBySource?: Record<string, PipelineCadence>;
  onClick: () => void;
}) {
  const ts = formatTimestamp(event.ts_utc);
  const cadence = cadenceBySource?.[event.source_system];
  const label = cadenceLabel(cadence, event.pipeline);
  const recordCount = extractRecordCount(event);

  return (
    <button className="log-row" onClick={onClick} title="Click for full event detail">
      <span className="col-time">{ts}</span>
      <span className={"col-level level-" + event.severity.toLowerCase()}>
        {event.severity}
      </span>
      <span className="col-source">{formatSource(event.source_system)}</span>
      <span className={"col-cadence cadence-" + cadenceClass(cadence, event.pipeline)}>
        {label}
      </span>
      <span className="col-msg">
        <span className="msg-text">{formatMessage(event.message, event.tenant_id)}</span>
        {recordCount !== null && (
          <span className="record-count" title="record_count from metrics">
            {recordCount.toLocaleString()} records
          </span>
        )}
      </span>
      <span className="col-label">{event.pipeline_label}</span>
    </button>
  );
}
